module.exports = __webpack_public_path__ + "static/media/bg1.c5804526.png";